import React, { useRef, useState } from "react";
import styles from "./HeroSlider.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";

const slides = [
    {
        image: "assets/imgs/home/home (1).jpg",
        label: "Kreativ · Modern · Einzigartig",
        title: "Asian Fusion Küche – Exzellenz asiatischer Aromen.",
        shortTitle: "Asian Fusion Cuisine. Neu interpretiert.",
        desc: "Entdecken Sie die harmonische Verbindung traditioneller Rezepte und moderner Akzente"
    },
    {
        image: "assets/imgs/home/home (2).jpg",
        label: "Präzision & Leidenschaft",
        title: "Die Kunst asiatischer Küche, modern veredelt.",
        shortTitle: "Die Essenz asiatischer Kulinarik",
        desc: "Feinste Zutaten treffen auf innovative Kochkunst für ein unvergleichliches Geschmackserlebnis."
    },
    {
        image: "assets/imgs/home/home (3).jpg",
        label: "Ein Fest für die Sinne",
        title: "Asian Fusion Küche – Eleganz. Balance. Geschmack.",
        shortTitle: "Eleganz. Balance. Harmonie.",
        desc: "Genießen Sie stilvolle Kulinarik und harmonische Momente in einer besonderen Atmosphäre."
    },
];

export default function HeroSlider(props) {
    const { handleClick } = props;
    const autoplayDelay = 6000;
    const [current, setCurrent] = useState(0);
    const swiperRef = useRef(null);

    const goToSlide = (index) => {
        if (swiperRef.current) {
            swiperRef.current.slideToLoop(index);
        }
    };

    return (
        <div className={styles.hero}>
            <Swiper
                modules={[Navigation, Pagination, Autoplay, EffectFade]}
                effect="fade"
                speed={1000}
                loop={true}
                autoplay={{
                    delay: autoplayDelay,
                    disableOnInteraction: false,
                }}
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
                onSlideChange={(swiper) => {
                    setCurrent(swiper.realIndex);
                }}
                className={styles.mySwiper}
            >
                {slides.map((slide, i) => (
                    <SwiperSlide key={i} className={styles.slide}>
                        <img className={styles.backgroundImage} src={slide.image} alt="" />
                        <div className={styles.overlay}></div>
                        
                        <div className={styles.content}>
                            <span className={styles.label}>
                                {slide.label}
                            <span className={styles.liningLabel}
                            ></span>
                            </span>
                            <h1 className={styles.title}>{slide.title}</h1>
                            <div className={styles.desc}>
                                {slide.desc}
                            </div>
                            <button className={styles.readMore} onClick={handleClick}>
                                <span>Tisch reservieren</span>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M7 17L17 7M17 7H7M17 7V17"/>
                                </svg>
                            </button>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            {/* Vertical Dots - Right Side */}
            <div className={styles.dotsVertical}>
                {slides.map((_, i) => (
                    <button
                        key={i}
                        className={`${styles.dot} ${current === i ? styles.dotActive : ''}`}
                        onClick={() => goToSlide(i)}
                    />
                ))}
            </div>

            {/* Bottom Navigation Bar */}
            <div className={styles.bottomNav}>
                {slides.map((slide, i) => (
                    <button
                        key={i}
                        className={`${styles.navItem} ${current === i ? styles.navItemActive : ''}`}
                        onClick={() => goToSlide(i)}
                    >
                        <div className={styles.navIcon}>
                            {i + 1}
                        </div>
                        <span className={styles.navText}>{slide.shortTitle}</span>
                    </button>
                ))}
            </div>
        </div>
    );
}